<template>
  <div class="sureorder" style="overflow: auto;">
    <!-- 自定义提示框 -->
    <div class="alsrtInfo" :style="{display: displayStsates}" ref="alertMsg">
      <div class="profPrompt_test">{{aletMsg}}</div>
    </div>
    <div class="address_title">
      <div class="address_title_left">
        <img src="../../images/dir_left.png" @click="_return()" />
      </div>确认订单
    </div>
    <div v-if="address" class="center_title" v-on:click="consignee()">
      <div class="center_title_img">
        <img src="../../images/address_label.png" />
      </div>
      <div class="center_title_text">
        <div>
          收货人：{{address.name}}
          <span>{{address.phone}}</span>
        </div>
        <div>{{address.addr}}&nbsp;&nbsp;&nbsp;{{address.address}}</div>
      </div>
      <div class="center_title_img1">
        <img src="../../images/dir_blue.png" class="center_title_img1_LMj"/>
      </div>
    </div>

    <!-- <div v-else class="center_title" v-on:click="consignee(false)">
      <div class="center_title_img">
        <img src="../../images/jia1.png" />
      </div>
      <div class="center_title_img1">
        <img src="../../images/dir_blue.png" />
      </div>
      <div class="center_title_text">
        <div>添加收货地址</div>
      </div>
    </div> -->

    <div class="message">
      <div>买家留言</div>
      <textarea :value="text_content" placeholder="50字以内（选填）" maxlength="50"></textarea>
    </div>

    <div class="list">
      <div class="list_title">
        <span>商品列表</span>
      </div>
      <div v-for="item in list" :key="item.id">
        <div class="divleft">{{item.name}}</div>
        <div class="divright">
          <div>
            ￥
            <span>{{item.money}}</span>
          </div>
          x {{item.count}}
        </div>
      </div>
    </div>

    <!-- <div class="pay"> -->
      <!-- <div class="pay1"> -->
        <span  class="pay1">支付方式：货到付款</span>
      <!-- </div> -->
      <div class="pay2">
        <span>商品应付金额：</span>
        <div >
          <span>￥</span>
          {{moneyNum}}
        </div>
      </div>
    <!-- </div> -->

    <button class="new" v-on:click="but()">提交订单</button>
  </div>
</template>
<script>
import API from "../../lmj_Api/api";

export default {
  data() {
    return {
      name: "shoppingcart",
      goods_id: this.$route.params.id,
      address: "",
      list: "",
      moneyNum: "",
      text_content: "",
      aletMsg: "", // 弹框提示语
      displayStsates: "none",
      uid: this.$store.getters.get_user_id,
    };
  },
  mounted() {
    var that = this;
    that.init();
  },
  methods: {
    alertDia(msg) {
      this.displayStsates = "block";
      this.aletMsg = msg;
      window.setTimeout(() => {
        this.displayStsates = "none";
      }, 1000);
    },

    //进入先执行函
    init() {
      var url = API.orderDetails;
      var thar = this;
      this.axios
        .post(url, {
          id: thar.goods_id,
          uid: thar.uid,
        })
        .then(res => {
          console.log(res);

          var data = res.data;
          if (data.code == 200) {
            this.address = data.address;
            this.list = data.data;
            this.moneyNum = data.moneyNum;
          }
        });
    },

    //提交订单
    but() {
        this.$dialog
          .confirm({
            // title: '标题',
            message: "是否提交订单",
            width: "5.46rem",
          })
          .then(() => {
            var that = this;
                console.log(that.text_content, that.goods_id,that.uid,)

            var url = API.order;
            this.axios.post(url, {
                msg: that.text_content,
                id: that.goods_id,
                user_id: that.uid,
              })
              .then(res => {
                console.log(res);
                if (res.data.code == 200) {
                  that.alertDia("订单提交成功");
                  setTimeout(() => {
                    that.$router.push({ name: "lmjhome" });
                  }, 1100);
                }
              });
          })
          .catch(() => {});
    },

    // 点击跳转管理地址
    consignee(address) {

        this.$router.push({
          path: "/addressmanagement"
        });
    },

    _return() {

      this.$router.push({name: 'gwhome'});
    }
  }
};
</script>



<style lang="less" scoped>
.alsrtInfo {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 999;
  .profPrompt_test {
    width: 4.2rem;
    height: 1.4rem;
    line-height: 1.4rem;
    border-radius: 0.2rem;
    color: #fff;
    position: absolute;
    background-color: rgba(0, 0, 0, 0.6);
    opacity: 0.6;
    top: 5.98rem;
    left: 50%;
    font-size: 0.28rem;
    font-family: Gotham-Book;
    opacity: 1;
    text-align: center;
    transform: translate(-50%, -50%);
  }
}
#app{
  height: 0;
}
.address_title {
  width: 7.5rem;
  height: 0.88rem;
  z-index: 999;
  position: fixed;
  top: 0;
  left: 0;
  background: linear-gradient(
    90deg,
    rgba(123, 212, 255, 1) 0%,
    rgba(92, 186, 255, 1) 100%
  );
  font-size: 0.3rem;
  font-family: PingFangSC-Medium, PingFang SC;
  color: rgba(255, 255, 255, 1);
  text-align: center;
  line-height: 0.88rem;
}

.address_title > div {
  position: absolute;
  top: 0rem;
  text-align: center;
}

.address_title > div > img {
  width: 0.18rem;
  height: 0.34rem;
  display: inline-block;
  vertical-align: middle;
}

.address_title > .address_title_left {
  left: 0rem;
  width: 1.06rem;
  height: 100%;
  line-height: 0.88rem;
}

.center_title {
  margin-top: 0.88rem;
  width: 100%;
  min-height: 1.52rem;
  border-bottom: 0.1rem solid rgba(237, 237, 237, 1);
  display: flex;
}

.center_title_img {
  width: auto;
  height: 1.52rem;
  line-height: 1.52rem;
  display: inline-block;
  vertical-align: middle;
  margin-left: 0.3rem;
  margin-right: 0.38rem;
  display: flex;
  align-items: center
}

.center_title_img > img {
  height: 0.3rem;
  display: inline-block;
  vertical-align: middle;
}

.center_title_text {
  width: 5.98rem;
  display: inline-block;
  vertical-align: middle;
  height: 100%;
}

.center_title_text > div {
  font-size: 0.3rem;
  font-family: PingFangSC-Medium, PingFang SC;
  color: rgba(109, 109, 109, 1);
  line-height: 0.42rem;
}

.center_title_text > div:nth-child(1) {
  margin-top: 0.3rem;
}

.center_title_text > div:nth-child(2) {
  margin-top: 0.08rem;
}

.center_title_img1 {
  margin-right: 0.3rem;
  height: 1.52rem;
  float: right;
}

.center_title_img1 > img {
  width: 0.28rem;
  height: 0.34rem;
  display: inline-block;
  vertical-align: middle;
}
.center_title_img1_LMj{
  width: 0.28rem;
  height: 0.34rem;
}
.message {
  width: 100%;
  height: 1.44rem;
  border-bottom: 0.1rem solid rgba(237, 237, 237, 1);
}

.message > div {
  margin-left: 0.3rem;
  margin-top: 0.22rem;
  font-size: 0.3rem;
  color: rgba(109, 109, 109, 1);
  font-family: PingFangSC-Medium, PingFang SC;
}

input::-webkit-input-placeholder {
  /* Chrome/Opera/Safari */
  color: rgba(153, 153, 153, 1);
}

input::-moz-placeholder {
  /* Firefox 19+ */
  color: rgba(153, 153, 153, 1);
}

input:-ms-input-placeholder {
  /* IE 10+ */
  color: rgba(153, 153, 153, 1);
}

input:-moz-placeholder {
  /* Firefox 18- */
  color: rgba(153, 153, 153, 1);
}

.message > textarea {
  font-size: 0.26rem;
  font-family: PingFangSC-Medium, PingFang SC;
  line-height: 0.36rem;
  border: 0rem;
  margin-left: 0.3rem;
  margin-top: 0.22rem;
  width: 90%;
  // text-indent: 0rem;
}

.list {
  width: 6.9rem;
  margin: auto;
  .list_title {
    height: 0.86rem;
  }
}
.list > div {
  border-bottom: 0.02rem solid rgba(237, 237, 237, 1);
  position: relative;
  height: 1.22rem;
}

.list > div > span {
  display: block;
  height: 0.86rem;
  line-height: 0.86rem;
  font-size: 0.3rem;
  font-family: PingFangSC-Medium, PingFang SC;
  color: rgba(109, 109, 109, 1);
}

.list > div > .divleft {
  position: absolute;
  top: 0.2rem;
  width: 4rem;
  height: 0.78rem;
  font-size: 0.28rem;
  line-height: 0.22rem;
  font-family: PingFangSC-Medium, PingFang SC;
  color: rgba(74, 74, 74, 1);
}

.list > div > .divright {
  margin-top: 0.22rem;
  height: 0.78rem;
  float: right;
  font-size: 0.24rem;
  font-family: PingFangSC-Regular, PingFang SC;
  color: rgba(153, 153, 153, 1);
  text-align: right;
}

.list > div > .divright > div {
  font-size: 0.22rem;
  font-family: PingFangSC-Medium, PingFang SC;
  color: rgba(74, 74, 74, 1);
  line-height: 0.22rem;
  margin-bottom: 0.8em;
}

.list > div > .divright > div > span {
  font-size: 0.32rem;
}
// .pay1 {
//   // margin-top: 0.1rem;
//   background:pink;
//   // height: 0.8rem;

// }

// .pay1 {
//   text-align: right;
//   margin-right: 0.3rem;
//   background:red;
//   height: 0.5rem;

// }

.pay1  {
  font-size: 0.26rem;
  color: #4A4A4A;
  font-weight: 400;
  margin: 0.22rem 0;
  display: block;
  text-indent: 4.9rem;
  font-family: PingFangSC-Regular, PingFang SC;
}

.pay2   {
  margin-right: 0.26rem;
  margin-bottom: 1.08rem;
  float: right;
  font-size: 0.26rem;
  font-family: PingFangSC-Medium, PingFang SC;
  color: #4A4A4A;
  font-weight: 400;
}

.pay2 > div{
  font-size: 0.4rem;
  color: #ff5d33;
  display: inline-block;
  // vertical-align: middle;
  > span {
  font-size: 0.24rem;
  color: rgba(255, 93, 51, 1);
}
}
 


.new {
  width: 7.5rem;
  height: 1.08rem;
  background: linear-gradient(
    90deg,
    rgba(123, 212, 255, 1) 0%,
    rgba(92, 186, 255, 1) 100%
  );
  font-size: 0.32rem;
  font-family: PingFangSC-Medium, PingFang SC;
  color: rgba(255, 255, 255, 1);
  line-height: 1.08rem;
  position: fixed;
  bottom: 0rem;
  left: 0rem;
  border: 0rem;
  border-radius: 0rem;
  outline: 0rem;
}
</style>



// WEBPACK FOOTER //
// src/components/lcx/shoppingcart.vue